module.exports = __webpack_public_path__ + "img/pigment_0.41bc1a65.png";